import { render, staticRenderFns } from "./CessaoTitulosV2.vue?vue&type=template&id=5f4d44c8&scoped=true"
import script from "./CessaoTitulosV2.vue?vue&type=script&lang=js"
export * from "./CessaoTitulosV2.vue?vue&type=script&lang=js"
import style0 from "./CessaoTitulosV2.vue?vue&type=style&index=0&id=5f4d44c8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4d44c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f4d44c8')) {
      api.createRecord('5f4d44c8', component.options)
    } else {
      api.reload('5f4d44c8', component.options)
    }
    module.hot.accept("./CessaoTitulosV2.vue?vue&type=template&id=5f4d44c8&scoped=true", function () {
      api.rerender('5f4d44c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CessaoTitulosV2.vue"
export default component.exports